export const getConfigSelector = state => state.config;

export const getConfigExternaSelector = state => state.configExterna;
